import { handleMoveShouldSetResponderCapture } from 'lib/handleMoveShouldSetResponderCapture';
import { theme } from 'lib/theme';
import React from 'react';
import { Insets, StyleProp, ViewStyle } from 'react-native';
import {
  KeyboardAwareScrollView,
  KeyboardAwareScrollViewProps,
} from 'react-native-keyboard-controller';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

type Props = {
  scrollIndicatorInsets?: Insets;
  scrollEnabled?: boolean;
  children: React.ReactNode;
  keyboardAvoiding?: boolean;
  enableSafeAreaBottom?: boolean;
  contentContainerStyle?: StyleProp<ViewStyle>;
  headerHeight?: number;
  contentPaddingTop?: number;
  contentPaddingBottom?: number;
  backgroundColor?: string;
  onLayout?: KeyboardAwareScrollViewProps['onLayout'];
};

export const ScrollView = ({
  scrollIndicatorInsets,
  scrollEnabled,
  children,
  keyboardAvoiding,
  enableSafeAreaBottom,
  contentContainerStyle,
  headerHeight,
  contentPaddingTop,
  contentPaddingBottom,
  backgroundColor,
  onLayout,
}: Props): React.ReactElement => {
  const { left, right, bottom } = useSafeAreaInsets();

  // const safeAreaBottom =
  //   enableSafeAreaBottom && safeAreaBottomIsRequired(!!isInModal) ? bottom : 0;
  const safeAreaBottom = enableSafeAreaBottom ? bottom : 0;

  const paddingTop = (headerHeight || 0) + (contentPaddingTop || 0);
  const paddingBottom = safeAreaBottom + (contentPaddingBottom || 0);
  return (
    <KeyboardAwareScrollView
      scrollEnabled={scrollEnabled}
      scrollIndicatorInsets={scrollIndicatorInsets}
      onMoveShouldSetResponderCapture={handleMoveShouldSetResponderCapture}
      enabled={keyboardAvoiding}
      contentContainerStyle={[
        {
          paddingTop,
          paddingBottom,
          paddingLeft: left,
          paddingRight: right,
        },
        contentContainerStyle,
      ]}
      style={{
        flex: 1,
        backgroundColor: backgroundColor || theme.colors.background,
      }}
      onLayout={onLayout}
    >
      {children}
    </KeyboardAwareScrollView>
  );
};
